import { lazy, Suspense } from 'react';
import { Layout } from 'components/themes/v1';

const ResetPassword = lazy(() => import('modules/account/ResetPassword'));

const ResetPasswordPage = (props) => (
  <Layout>
    <Suspense fallback={null}>
      <ResetPassword />
    </Suspense>
  </Layout>
);

export default ResetPasswordPage;
